import { render, staticRenderFns } from "./AskSupportModal.vue?vue&type=template&id=6a99d37b&scoped=true&"
import script from "./AskSupportModal.vue?vue&type=script&lang=ts&"
export * from "./AskSupportModal.vue?vue&type=script&lang=ts&"
import style0 from "./AskSupportModal.vue?vue&type=style&index=0&id=6a99d37b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a99d37b",
  null
  
)

export default component.exports